import { render, staticRenderFns } from "./ShowRegional.vue?vue&type=template&id=6da70b6f&"
import script from "./ShowRegional.vue?vue&type=script&lang=js&"
export * from "./ShowRegional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports